import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 4.75a2 2 0 0 1 2-2h12.5a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-5.63a1 1 0 0 0-.65.24l-3.22 2.76v-2a1 1 0 0 0-1-1h-2a2 2 0 0 1-2-2v-7.5Z"
	})]
});
const ForwardRef = forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
